import React, { Fragment, useEffect, useState } from "react";
import { AppCard } from "../../global/AppCard";

import MyLoader from "../../util/MyLoader";
import { getApps } from "./api";
import { MyModal } from "../../global/MyModal";
import { Download } from "lucide-react";
import { SolidButton } from "../../global/SolidButton";
import { set } from "date-fns";
// const apps = [
//   {
//     id: "mangocash",
//     name: "MangoCash",
//     package: "com.moon.mangocash",
//     version: "1.0.0",
//     createdAt: "12 Jan 2024, 10:00 AM",
//     os:'android'
//   },
//   {
//     id: "CashInLoop",
//     name: "CashInLoop Web",
//     package: "com.adwave.cashinloop ",
//     version: "1.3.0",
//     createdAt: "12 Jan 2024, 10:00 AM",
//     os:'web'
//   },
// ];

export function AppsManage({ onToggleHome }) {
  // const apps= appData;
  const [loading, setLoading] = useState(true);
  const [apps, setApps] = useState([]);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [appName, setAppName] = useState(null);
  const [serverName, setServerName] = useState(null);
  const [packageName, setPackageName] = useState(null);
  const [domain, setDomain] = useState(null);
  const [des, setDes] = useState(null);
  const [icon, setIcon] = useState(null);
  const [isViewPhoto, setIsViewPhoto] = useState(false);
  const [photo, setPhoto] = useState(null);

  useEffect(() => {
    const fetchApps = async () => {
      try {
        const res = await getApps();

        setApps(res.data?.apps || []); // ✅ THIS LINE
      } catch (err) {
        console.error("Failed to fetch apps", err);
        //setCampaigns([]);
      } finally {
        setLoading(false);
      }
    };

    fetchApps();
  }, []);

  if (loading) return <MyLoader />;

  return (
    <Fragment>
      <div className="space-y-4">
        {/* app grid */}
        <div className="grid grid-cols-1 md:grid-cols-1 sm:grid-cols-1 lg:grid-cols-3 gap-6">
          {apps.map((item) => (
            <div key={item.id}>
              <AppCard
                aKey={item.id + item.name}
                onToggleHome={onToggleHome}
                app={item}
                onEdit={(app) => {
                  setIsModelOpen(true);
                  setAppName(app.name);
                  setServerName(app.svr_name);
                  setPackageName(app.package_name);
                  setDomain(app.domain);
                  setDes(app.short_des);
                  setIcon(app.icon);
                }}
                onIcon={(url) => {
                  setPhoto(url);
                  setIsViewPhoto(true);
                }}
              />
            </div>
          ))}
          {/* <AppCard/>
            <AppCard/> */}
        </div>
      </div>
      <MyModal
        isOpen={isModelOpen}
        onClose={() => setIsModelOpen(false)}
        title="Edit App"
        width="530px"
      >
        <div className="flex flex-col space-y-4 ">
          <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4">
            {/* app name */}
            <div className="mt-2 col-span-1">
              <label className="block text-xs font-medium text-slate-500 mb-2">
                App Name*
              </label>

              {/* Input */}
              <input
                type="text"
                placeholder="e.g. MangoCash"
                value={appName}
                onChange={(e) => {
                  setAppName(e.target.value);
                  if (errors.appName)
                    setErrors((prev) => ({ ...prev, appName: undefined }));
                }}
                className={`w-full text-xs py-2.5 px-3  bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all   ${
                  errors.appName
                    ? "border-red-400"
                    : "border-slate-200 dark:border-slate-700"
                }`}
              />
              {errors.appName && (
                <div className="text-xs text-red-500 mt-1">
                  {errors.appName}
                </div>
              )}
            </div>
            {/* Server name */}
            <div className="mt-2 col-span-1">
              <label className="block text-xs font-medium text-slate-500 mb-2">
                Server Name*
              </label>

              {/* Input */}
              <input
                type="text"
                placeholder="e.g. pandaking.fun"
                value={serverName}
                onChange={(e) => {
                  setServerName(e.target.value);
                  if (errors.serverName)
                    setErrors((prev) => ({ ...prev, serverName: undefined }));
                }}
                className={`w-full text-xs py-2.5 px-3  bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all   ${
                  errors.serverName
                    ? "border-red-400"
                    : "border-slate-200 dark:border-slate-700"
                }`}
              />
              {errors.serverName && (
                <div className="text-xs text-red-500 mt-1">
                  {errors.serverName}
                </div>
              )}
            </div>
            {/* Package name */}
            <div className="mt-2 col-span-1">
              <label className="block text-xs font-medium text-slate-500 mb-2">
                Package Name*
              </label>

              {/* Input */}
              <input
                type="text"
                placeholder="e.g. pandaking.fun"
                value={packageName}
                onChange={(e) => {
                  setPackageName(e.target.value);
                  if (errors.packageName)
                    setErrors((prev) => ({ ...prev, packageName: undefined }));
                }}
                className={`w-full text-xs py-2.5 px-3  bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all   ${
                  errors.packageName
                    ? "border-red-400"
                    : "border-slate-200 dark:border-slate-700"
                }`}
              />
              {errors.packageName && (
                <div className="text-xs text-red-500 mt-1">
                  {errors.packageName}
                </div>
              )}
            </div>
            {/* Domain */}
            <div className="mt-2 col-span-1">
              <label className="block text-xs font-medium text-slate-500 mb-2">
                Domain*
              </label>

              {/* Input */}
              <input
                type="text"
                placeholder="e.g. pandaking.fun"
                value={domain}
                onChange={(e) => {
                  setDomain(e.target.value);
                  if (errors.domain)
                    setErrors((prev) => ({ ...prev, domain: undefined }));
                }}
                className={`w-full text-xs py-2.5 px-3  bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all   ${
                  errors.domain
                    ? "border-red-400"
                    : "border-slate-200 dark:border-slate-700"
                }`}
              />
              {errors.domain && (
                <div className="text-xs text-red-500 mt-1">{errors.domain}</div>
              )}
            </div>
            {/* Short Description */}
            <div className="mt-2 col-span-2">
              <label className="block text-xs font-medium text-slate-500 mb-2">
                Short Description*
              </label>

              {/* Input */}
              <textarea
                type="text"
                placeholder="e.g. MangoCash is a revolutionary app that allows "
                value={des}
                onChange={(e) => {
                  setDes(e.target.value);
                  if (errors.des)
                    setErrors((prev) => ({ ...prev, des: undefined }));
                }}
                className={`w-full text-xs py-2.5 px-3  bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all   ${
                  errors.des
                    ? "border-red-400"
                    : "border-slate-200 dark:border-slate-700"
                }`}
              />
              {errors.des && (
                <div className="text-xs text-red-500 mt-1">{errors.des}</div>
              )}
            </div>
            <div className="flex flex-col items-center justify-center border-2 rounded-lg border-dashed space-y-1 border-slate-300/50 dark:border-slate-300/50 text-slate-500  col-span-1 mt-4 py-6">
              <Download size={30} />
              <span className="text-xs font-semibold mt-2  ">
                Upload New Icon
              </span>
              <span className="text-xs text-slate-500 dark:text-slate-500  font-normal">
                PNG,JPG upto 5MB
              </span>
            </div>
            {/* Icon Preview */}
            <div className="flex flex-col items-center justify-start border-2 rounded-lg  space-y-1 border-slate-300/50 dark:border-slate-300/20 text-slate-500  col-span-1 mt-4 p-3">
              <span className="text-xs mr-auto font-semibold ">Preview</span>
              <img className="w-[70px] h-[70px] m-auto" src={icon} alt="Icon" />
            </div>
          </div>
          <div className=" flex items-end w-full justify-end gap-4 mt-4    ">
            <button
              className="px-4 py-2 rounded-lg 
                                       bg-slate-400/20 dark:bg-slate-800 
                                       text-slate-800 dark:text-slate-300 text-sm font-semibold
                                       hover:bg-slate-400/30 dark:hover:bg-slate-700 
                                       transition-all duration-300 "
              onClick={() => {
                setIsModelOpen(false);
                setErrors({});
              }}
            >
              Cancel
            </button>
            <SolidButton
              className=""
              children={<span>Update App</span>}
              onClick={() => {
                //  handleSubmit(e);
              }}
            />
          </div>
        </div>
      </MyModal>
      {/* Priveiw Image */}
      <MyModal
        title={"Preview Image"}
        isOpen={isViewPhoto}
        onClose={() => {
          setIsViewPhoto(false);
        }}
        width="460px"
      >
        <div className="p-2 mt-2">
          <img
            src={photo}
            referrerPolicy="no-referrer"
            alt="profile"
            className="w-full  object-cover rounded-2xl"
          />
        </div>
      </MyModal>
    </Fragment>
  );
}
